import React from 'react';

import { LinkHelper, ShareHelper } from '../helpers'

export const WhatsAppIcon = ({ className = '' }) => (
    <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
)

export const EmailIcon = ({ className = '' }) => (
    <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="M3 7l9 7 9-7" />
    </svg>
)

export const PhoneIcon = ({ className = '' }) => (
    <svg className={className} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
    </svg>
)

const LinkedInIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M4.98 3.5C4.98 4.881 3.87 6 2.5 6S.02 4.881.02 3.5C.02 2.12 1.13 1 2.5 1s2.48 1.12 2.48 2.5zM.22 8.98h4.56V23H.22V8.98zM8.34 8.98h4.37v1.91h.06c.61-1.15 2.1-2.36 4.32-2.36 4.62 0 5.47 3.04 5.47 7v7.47h-4.56v-6.63c0-1.58-.03-3.61-2.2-3.61-2.2 0-2.54 1.72-2.54 3.5V23H8.34V8.98z" />
    </svg>
)

const ContactLinks = ({ className = '', contact, labeled = false }) => {
    const link = LinkHelper.referralLink(contact.referral_code?.code)

    const whatsAppMessage = link

    const mailSubject = "Invitation to join RetailCircle"
    const mailBody = link

    const onWhatsAppClick = (e) => {
        e.preventDefault()
        ShareHelper.whatsapp(whatsAppMessage, contact.phone)
    }

    const mailHref = `mailto:${encodeURIComponent(contact.email)}?subject=${encodeURIComponent(mailSubject)}&body=${encodeURIComponent(mailBody)}`

    return (
        <div className={`contact contact-links d-flex${labeled ? ' contact-links--labeled' : ''} ${className}`}>
            { contact.phone    && (
                <a onClick={onWhatsAppClick} href="" className="whatsapp align-self-center" aria-label="WhatsApp">
                    <WhatsAppIcon />
                    {labeled && <span className="contact-links__label">WhatsApp</span>}
                </a>
            )}
            { contact.linkedin && (
                <a href={contact.linkedin} target="_blank" rel="noreferrer" className="linkedin align-self-center" aria-label="LinkedIn">
                    <LinkedInIcon />
                    {labeled && <span className="contact-links__label">LinkedIn</span>}
                </a>
            )}
            { contact.email    && (
                <a href={mailHref} className="email align-self-center" aria-label="Email">
                    <EmailIcon />
                    {labeled && <span className="contact-links__label">Email</span>}
                </a>
            )}
        </div>
    )
}

export default ContactLinks
